import { createContext, useContext } from 'react';
import { Product } from '../../../entities/product.entity';

export type ProductCardActions = {
  onToggleWishlist?: (product: Product) => void;
  onAddToCart?: (product: Product) => void;
  isWishlisted?: (productId: string) => boolean;
  isWishlistLoading?: (productId: string) => boolean;
};

export const ProductCardActionsContext = createContext<ProductCardActions>({});

export function useProductCardActions() {
  return useContext(ProductCardActionsContext);
}
